<div class="modal-header">
  <h3 class="modal-title">
    {{ modalTitle }}
    <i class="fa fa-times pull-right" style="cursor: pointer;" (click)="cancel()"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
  </h3>
</div>

<div class="modal-body" [hidden]="minimise">
  <div class="entityDetails">
    <table style="width: 100%;">
      <tbody>
        <tr>
          <td class="layer-line" nowrap>Current Year Entity:</td>
          <td class="layer-data" nowrap>{{ entityDisplayLine }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div style="margin: 10px">
    <label>Notes required greater than 5% change or over 2,000,000:</label>
    <textarea class="form-control input-sm" name="localAcountDescInput"
      [(ngModel)]="localacctdesc_new" rows="3"></textarea>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="btn btn-info btn-sm" type="button" [disabled]="reclassTotal != 0 || crudLoading" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-danger-outline btn-sm" type="button" (click)="reset()">Reset</button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>
